<template>
</template>
<script type="text/javascript">
	var http=process.env.API_ROOT;
export default{
  http
}
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/global.vue